<app-page-header
  [className]="'mb-1!'"
  [pageTitle]="'Editar zona'"
  [showBreadcrumb]="true"
  [backRoute]="'../'"
  [backLabel]="'Zonas'"
  [currentRoute]="'Editar zona'"
/>

<div class="mt-6">
  @if (loading) {
    <app-spinner />
  } @else {
    <app-card
      [title]="'Datos de la zona'"
      [showEditButton]="permissionAuth.canEdit('zonas')"
      [editable]="editable"
      [editTooltip]="'Editar zona'"
      (onEditClick)="editableSwitcher()">
      <app-form [formGroup]="editForm">
        <div class="grid grid-cols-1 gap-3 md:grid-cols-2 mb-5">
          <!-- Nombre -->
          <div>
            <app-label for="nombre">
              Nombre de la zona
            </app-label>
            <app-input-field id="nombre" type="text" formControlName="nombre" placeholder="Ingrese el nombre de la zona" />
          </div>

          <!-- País -->
          <div>
            <app-label for="ubi_pais_id">
              País
            </app-label>
            <app-select id="ubi_pais_id" formControlName="ubi_pais_id" placeholder="Seleccione un país" [options]="paises | toSelectOptions" />
          </div>

          <!-- Departamento -->
          <div>
            <app-label for="ubi_departamento_id">
              Departamento
            </app-label>
            <app-select id="ubi_departamento_id" formControlName="ubi_departamento_id" placeholder="Seleccione un departamento" [options]="departamentos | toSelectOptions" />
          </div>

          <!-- Ciudad -->
          <div>
            <app-label for="ubi_ciudad_id">
              Ciudad
            </app-label>
            <app-select id="ubi_ciudad_id" formControlName="ubi_ciudad_id" placeholder="Seleccione una ciudad" [options]="ciudades | toSelectOptions" />
          </div>

        </div>
      </app-form>
    </app-card>

    <app-edition-buttons *hasPermission="'zonas:edit'"
      [valid]="editForm.valid"
      [process]="process"
      [editable]="editable"
      [hideEditButton]="true"
      (onEditClick)="editableSwitcher()"
      (onGoBackClick)="goBack()"
      (onCancelClick)="refreshZona()"
      (onUpdateClick)="updateZona()"
    />
  }
</div>
